import React, { useContext } from 'react';
import { arrayOf, string, bool, func } from 'prop-types';
import { Image } from '@thd-olt-component-react/core-ui';
import { Carousel } from '@one-thd/sui-carousel';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { publish } from '../utils/publisher';

const SupplementalTilesCarousel = ({
  productsData, schemaName, isDrawerShow, onClickShowDrawer
}) => {

  const handleImageClick = (idx) => {

    publish({
      componentName: 'supplemental-recs',
      eventName: 'click',
      data: {
        position: idx + 1,
        schemaName
      }
    });
  };

  const { channel } = useContext(ExperienceContext);

  const isMobile = channel === 'mobile';

  return (
    <>
      {productsData?.length
        && (
          <Carousel
            breakpoints={{
              sm: {
                slidesPerView: 3,
                slidesPerGroup: 3
              },
              md: {
                slidesPerView: 4,
                slidesPerGroup: 4
              },
              lg: {
                slidesPerView: 5,
                slidesPerGroup: 5
              },
              xl: {
                slidesPerView: 6,
                slidesPerGroup: 6
              }
            }}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...(isMobile ? ({ slidesPerGroup: 2 }) : {})}
          >
            {
              productsData.map((prod, idx) => {
                const imageUrl = prod?.product?.media?.images?.[0]?.url;
                const { productLabel } = prod?.product?.identifiers;
                const itemId = prod?.product.itemId;

                return (
                  <div key={itemId}>
                    <meta data-prop="name" content={itemId} />
                    { isDrawerShow
                      ? (
                        <Image
                          src={imageUrl?.replace(/<SIZE>/gi, '300')}
                          lazy
                          stretchy
                          alt={productLabel}
                          title={productLabel}
                          onClick={onClickShowDrawer}
                        />
                      )
                      : (
                        <a
                          href={prod?.product?.identifiers?.canonicalUrl}
                          onClick={() => handleImageClick(idx)}
                        >
                          <Image
                            src={imageUrl?.replace(/<SIZE>/gi, '300')}
                            lazy
                            stretchy
                            alt={productLabel}
                            title={productLabel}
                          />
                        </a>
                      )}
                  </div>
                );
              })
            }
          </Carousel>
        )}
    </>
  );
};

SupplementalTilesCarousel.propTypes = {
  productsData: arrayOf(Object),
  schemaName: string,
  isDrawerShow: bool,
  onClickShowDrawer: func
};

SupplementalTilesCarousel.defaultProps = {
  productsData: null,
  schemaName: '',
  isDrawerShow: null,
  onClickShowDrawer: () => {}
};

export { SupplementalTilesCarousel };